import React, { ReactElement, useEffect, useState } from 'react';
import { Button, Col, Row, Space } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { GUTTOR_SPACE, NOT_ELIGIBLE_INSURER_ERR, POLICY_NOT_ELIGIBLE } from '../../../../../../shared/constants/commonConstants';
import { RootState } from '../../../../../../store';
import * as actions from '../../../../../../store/actions/newAdmissionAction';
import { AdmissionForm, NewAdmissionState } from '../../../../../../store/models/newAdmissionModel';
import { updateAdmissionFormValue, findKeyValuePair, getIsPageNameNewAdmission, customGTMEvent } from '../../../service/crmUtils';
import BeneficiaryCard from '../cards/BeneficiaryCard/BeneficiaryCard';
import BeneficiarySearchPanel from '../BeneficiarySearchPanel/BeneficiarySearchPanel';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import { centeredNotification } from '../../../../../../utils/utility';
import { getDateWithTextMonth } from '../../../../../../utils/dateTimeUtils';
import { useSmoothScroll } from '../../../../../../shared/hooks/useSmoothScroll';
import AutoPopulateProcedures from '../AutoPopulateProceduresModal/AutoPopulateProcedures';
import { useMigrateClaimDetail } from '../../../../../../shared/hooks/useMigrateClaimDetail';
import { BENEF_WARNING_MESSAGE, DEFAULT_ADMISSION_FORM_VALUE, GENERIC_DISABLED_BENEF_MESSAGE, OTHER_ID } from '../../../../../../shared/constants/crmConstants';
import RPABeneficiarySearchPanel from '../RPABeneficiarySearchPanel/RPABeneficiarySearchPanel';
import { ReactComponent as Info_Icon } from '../../../../../../assets/images/svg/information_Icon.svg';
import { ReactComponent as Warning_Icon } from '../../../../../../assets/images/svg/warning_icon.svg';
import { ReactComponent as Exception_Icon } from '../../../../../../assets/images/svg/Exception.svg';
import PanelCollapse from '../../../../../../shared/components/collapse/PanelCollapse';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { cloneDeep } from 'lodash';
import { setBeneficiaryList, setBeneficiarySearchResponsePayerId, setShowBeneficiaryCard, setShowPayerNotConfiguredMessage } from '../../../../../../store/actions/newAdmissionAction';
import BlueBgInformativeAlert from '../../../../../../shared/components/Alert/BlueBgInformativeAlert';
import CONTROL_CONFIG_BASED_ON_PAYER from '../../../../../../config/formControlConfig';

const BeneficiarySearch = ({ form, detailNav, location: { pathname }, prefillOldData = true }: any): ReactElement | null => {
  useSmoothScroll('benef-search');
  const dispatch = useDispatch();
  const [isOldDataLoading, setIsOldDataLoading] = useState<boolean>(false);
  const [isAutoPopulateModalVisible, setIsAutoPopulateModalVisible] = useState(false);
  const [tempBeneficiary, setTempBeneficiary] = useState<any>(null);
  const [oldClaimDetail, setOldClaimDtail] = useState<any>(null);
  const [tempClaimDetail, setTempClaimDetail] = useState(null);
  const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(false);
  const [setBenefValue, setIsBenefValue] = useState<string | { nameMatchMessage: string, percentageNameMatch: string,
    isLimitedCashless: boolean }>('');
  const [icon, setIcon] = useState<any>(null);
  const [collapseKey, setCollapseKey] = useState<string | null>('1');
  const [text, setText] = useState<any>([]);
  const {beneficiarySearchResponsePayerId, beneficiarySearchResponsePayerName, showPayerNotConfiguredMessage, showBeneficiaryCard}: any =
  useSelector((state: RootState): NewAdmissionState =>  state.newAdmission);
  const {selectedPatientDetail} = useSelector((state: RootState): any => state?.hospital);
  useMigrateClaimDetail(isOldDataLoading, false, oldClaimDetail);
  const { isDraftSelected } = useSelector((state: RootState): NewAdmissionState => state.newAdmission);

  const {
    selectedTab, admissionFormVal, beneficiaryList, isLoadingPreData, isBeneficiaryPopUpRequired, isShowAdmissionForm,
    selectedMemberCardIndex, selectedBeneficiaryDetail, allowNextStage, starDisabledBenefMessage,
  } = useSelector((state: RootState): NewAdmissionState =>
    state.newAdmission);
  const { payerList: { payer: { uniqueIdentifier, isRpaPayer, name }, allPayers }, payerLookUp } =
    useSelector((state: RootState): RootState => state);
  const payerConfig = CONTROL_CONFIG_BASED_ON_PAYER[name];
  const payerConfigValues = Object.values(payerConfig || '');
  const disableCardsBenefPayer = payerConfigValues?.some((config: any): any => Boolean(config?.showProductName));

  const onOldClaimSuccess = (claimDetail?: any): any => {
    setIsOldDataLoading(false);
    if (claimDetail) {
      setIsAutoPopulateModalVisible(true);
      setTempClaimDetail(claimDetail);
    } else {
      setOldClaimDtail(null);
      setTempClaimDetail(null);
      onSkip();
    }
  };

  useEffect((): any => {
    if (tempBeneficiary) {
      if (prefillOldData) {
        setIsOldDataLoading(true);
        tempBeneficiary.memberGenderSelect = tempBeneficiary?.memberGenderSex;
        dispatch(actions.getOldClaimDetails(tempBeneficiary, onOldClaimSuccess));
      } else {
        setIsOldDataLoading(false);
        onSkip();
      }
    }
  }, [tempBeneficiary]);

  useEffect((): any => {
    if (typeof setBenefValue === 'object') {
      (setBenefValue?.percentageNameMatch <= '90' && setBenefValue?.percentageNameMatch >= '60') ? setIcon('Warning') :
      (setBenefValue?.percentageNameMatch < '60') ? setIcon('Error') : setIcon('');
    }
  }, [setBenefValue]);
  useEffect((): any => {
    dispatch(actions.setIsArtemis(false));
    const handleOutsideClick = (e: any): any => {
      if (!document.querySelector('.benefPopUpModal')?.contains(e.target)) {
        setIsConfirmModalVisible(false);
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);

    return (): any => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, []);

  useEffect((): any => {
    if (isShowAdmissionForm) {
      setCollapseKey(null);
    } else {
      setCollapseKey('1');
    }
  }, [isShowAdmissionForm]);

  useEffect((): any => {
    if (beneficiarySearchResponsePayerId > 0) {
      const finalPayer = allPayers.find((p: any): any => (p.id === beneficiarySearchResponsePayerId && p.isGovtScheme === false));
      if (!finalPayer) {
        dispatch(setBeneficiaryList([]));
        dispatch(setShowBeneficiaryCard(false));
        dispatch(setShowPayerNotConfiguredMessage(true));
        const disabledPayer = beneficiarySearchResponsePayerName ? beneficiarySearchResponsePayerName : beneficiarySearchResponsePayerId;
        setText(['Member belongs to ', <b key="text3">{disabledPayer}</b>,
        '. Hospital is ', <b key="text4">not in the network</b>, ' of ', `${disabledPayer}`]);
        dispatch(setBeneficiarySearchResponsePayerId(0));
      }
    }
  }, [beneficiarySearchResponsePayerId]);

  const onProceed = (): any => {
    setOldClaimDtail(tempClaimDetail);
    dispatch(actions.setAutoPopulateDayCareProcedure(true));
    setIsAutoPopulateModalVisible(false);
    openForm();
  };

  const onSkip = (): any => {
    setOldClaimDtail(null);
    setTempClaimDetail(null);
    const { memberName = '' , roomType } = tempBeneficiary;
    const formVal = updateAdmissionFormValue(
      tempBeneficiary, admissionFormVal as AdmissionForm, payerLookUp[uniqueIdentifier]?.insurerName, selectedPatientDetail,
    );

    const selectedRoom = findKeyValuePair(payerLookUp[uniqueIdentifier]?.roomType, 'payerMasterValue', roomType);
    if (selectedRoom) {
       form.setFieldsValue({
         ...formVal[detailNav[selectedTab >= 0 ? selectedTab : 0].formKey],
         hospitalRoomType: OTHER_ID, payerRoomType: selectedRoom?.value,
         inPatientNumber: selectedPatientDetail?.patientDetails?.inpatientNumber || selectedPatientDetail?.lastIPID,
       });
       dispatch(actions.disableRoomType(true));
       dispatch(actions.toggleOtherRoomType(true));
    }
    form.setFieldsValue({
      inPatientNumber: selectedPatientDetail?.patientDetails?.inpatientNumber || selectedPatientDetail?.lastIPID,
    });
    dispatch(actions.setAdmissionForm(formVal));
    dispatch(actions.setMemberName(memberName));
    setIsAutoPopulateModalVisible(false);
    openForm();
  };

  const openForm = (): any => {
    const { policyEndDate } = tempBeneficiary || {};
    if (policyEndDate && moment().isAfter(moment(policyEndDate))) {
      centeredNotification(`Policy expiry date is ${getDateWithTextMonth(policyEndDate)}.`, 'info');
    }
    if (typeof setBenefValue === 'object' && setBenefValue?.isLimitedCashless) {
      dispatch(actions.setIsShowAdmissionForm(false));
      centeredNotification(POLICY_NOT_ELIGIBLE, 'error');
    } else {
      dispatch(actions.setSelectedBeneficiary(tempBeneficiary));
      dispatch(actions.setPercentageNameMatch(tempBeneficiary?.percentageNameMatch));
      dispatch(actions.setGovtSchemeUrn(tempBeneficiary?.urn));
      dispatch(actions.setIsShowAdmissionForm(true));
      dispatch(actions.updateAdmissionStartTime(moment().utcOffset('+05:30').format()));
      setIsAutoPopulateModalVisible(false);
    }
  };

  let isBenefSearchShow = true;

  if (!getIsPageNameNewAdmission(pathname) || isDraftSelected) {
    isBenefSearchShow = false;
  }

  const proceedCheck = (selectedBenef: any, index: any): any => {
    if (!allowNextStage) {
      centeredNotification(disableCardsBenefPayer ? starDisabledBenefMessage : GENERIC_DISABLED_BENEF_MESSAGE);
       return;
    }
    customGTMEvent({
      event : 'MEMBER_CARD_SELECTED',
      membersFound: beneficiaryList?.length ?? 'N/A',
    });
    selectedBenef.index = index;
    setIsBenefValue(selectedBenef);
    (beneficiaryList.length > 1 &&  (selectedBenef !== selectedBeneficiaryDetail) ) ?
    setIsConfirmModalVisible(true) : checkIsMemberAllowedAsPerInsurer(selectedBenef);
  };

  const checkIsMemberAllowedAsPerInsurer = (selectedBenef: any): any => {
    if (beneficiaryList?.length > 1 && selectedBenef !== selectedBeneficiaryDetail) {
      form?.resetFields();
      dispatch(actions.setAdmissionForm(cloneDeep(DEFAULT_ADMISSION_FORM_VALUE)));
    }
    const submissionAllowed = findKeyValuePair(
      (payerLookUp[uniqueIdentifier]?.providerSpecificInsurers || []), 'value', selectedBenef?.insuranceCompanyId, true);
    if (payerLookUp[uniqueIdentifier]?.isHospSpecificInsurerPayerResponse && selectedBenef?.insuranceCompanyId && !submissionAllowed) {
      centeredNotification(NOT_ELIGIBLE_INSURER_ERR(selectedBenef?.insuranceCompanyName));
      return;
    }
    setTempBeneficiary(selectedBenef);
    dispatch(actions.setSelectedBenfStatus(selectedBenef?.status));
    dispatch(actions.setSelectedCardIndex(selectedBenef?.index));
  };

   const setExpandIcon = (panelProps: any): any => {
    const isActive = collapseKey?.includes(panelProps.panelKey);
    return isActive ? <UpOutlined /> : <DownOutlined />;
  };
  if (!isBenefSearchShow) {
    return null;
  }
  return <>
  <PanelCollapse
    activeKey={collapseKey}
    keyName= "1"
    header="Member Search"
    onChange={(): any => setCollapseKey(collapseKey === '1' ? null : '1')}
    expandIcon = {setExpandIcon}

    >
    <div> {
    (isRpaPayer && !disableCardsBenefPayer) ? <RPABeneficiarySearchPanel form={form} isLoading={isLoadingPreData} /> :
      <BeneficiarySearchPanel form={form} isLoading={isLoadingPreData} />
    }
    {
      showPayerNotConfiguredMessage &&
      <Row gutter={GUTTOR_SPACE} className="flex flex-element justify-center align-center">
        <BlueBgInformativeAlert okButtonRequired={false} text={text}/>
      </Row>
    }
    <Row gutter={GUTTOR_SPACE} data-testid="beneficiary-cards" className="old-beneficiary-cards">
      {isConfirmModalVisible && (
        <div className="benefPopUpModal"
        >
        {isBeneficiaryPopUpRequired ? <div className="modal_icon">
          {icon === 'Warning' ? <Warning_Icon /> : icon === 'Error' ? <Row style={{justifyContent: 'center'}}><Col className="benef-popup-icon"><Exception_Icon /></Col>
           <Col style={{marginTop: '5px'}}>Low Match Alert:</Col></Row> : <></>}
        </div> : <></>}
        {isBeneficiaryPopUpRequired ?
        <div
          className="benef-pop-message"
          dangerouslySetInnerHTML={{
          __html: typeof setBenefValue === 'object' ? setBenefValue.nameMatchMessage : `<div>
            Are you sure you have selected the right member? Please click on 'Proceed' to
          continue or click 'Back' to choose the right member.</div>`,
          }}
        /> : <div>
          Are you sure you have selected the right member? Please click on 'Proceed' to
        continue or click 'Back' to choose the right member.</div>
        }
        <div className="modalButtons">
        <Space direction="horizontal" size="large">
        <Button
        key="close"
        type="default"
        className="beneficiary-confirm-cancel"
        onClick={(): any => setIsConfirmModalVisible(false)}
        >
        Back
        </Button>
        <Button
        key="submit"
        type="primary"
        className="beneficiary-confirm-proceed"
        onClick={(): any => {
        setIsConfirmModalVisible(false);
        checkIsMemberAllowedAsPerInsurer(setBenefValue);
        }}
        >
        Proceed
        </Button>
        </Space>
        </div>
        <div className="msgDiv">
        <Info_Icon /><span className="messageDiv">{BENEF_WARNING_MESSAGE}</span>
        </div>

        </div>
      )}

      { showBeneficiaryCard &&
        beneficiaryList.map((beneficiary: any, index: number): ReactElement => {
          return <>
            <Col md={12} key={index}
              onClick={(): void => { !isConfirmModalVisible
              && beneficiary !== selectedBeneficiaryDetail && proceedCheck(beneficiary, index); }}>
              <BeneficiaryCard
                isSelected={beneficiary === setBenefValue}
                loading={isOldDataLoading}
                beneficiary={beneficiary}
                index={index}
                isBeneficiaryPopUpRequired= {isBeneficiaryPopUpRequired}
                isConfirmed = {index === selectedMemberCardIndex }
                disabled = {!allowNextStage}

              />
            </Col>
            </>;
        })
      }
    </Row>
    {
      !isConfirmModalVisible &&
      <AutoPopulateProcedures
        claimDetail={tempClaimDetail}
        visible={isAutoPopulateModalVisible}
        handleProceed={onProceed}
        handleSkip={onSkip}
        />
    }
  </div>
  </PanelCollapse>
  </>;
};

export default withRouter(BeneficiarySearch);
